!function (a, e) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define(e) : (a.ReactIntlLocaleData = a.ReactIntlLocaleData || {}, a.ReactIntlLocaleData.mt = e());
}(this, function () {
  "use strict";

  return [{
    locale: "mt",
    pluralRuleFunction: function pluralRuleFunction(a, e) {
      var i = String(a).split("."),
          n = Number(i[0]) == a && i[0].slice(-2);
      return e ? "other" : 1 == a ? "one" : 0 == a || n >= 2 && n <= 10 ? "few" : n >= 11 && n <= 19 ? "many" : "other";
    },
    fields: {
      year: {
        displayName: "Sena",
        relative: {
          0: "din is-sena",
          1: "is-sena d-dieħla",
          "-1": "is-sena l-oħra"
        },
        relativeTime: {
          future: {
            one: "fi żmien sena",
            few: "fi żmien {0} snin oħra",
            many: "fi żmien {0} snin oħra",
            other: "fi żmien {0} snin oħra"
          },
          past: {
            one: "sena ilu",
            few: "{0} snin ilu",
            many: "{0} snin ilu",
            other: "{0} snin ilu"
          }
        }
      },
      "year-short": {
        displayName: "Sena",
        relative: {
          0: "din is-sena",
          1: "is-sena d-dieħla",
          "-1": "is-sena l-oħra"
        },
        relativeTime: {
          future: {
            one: "fi żmien sena",
            few: "fi żmien {0} snin oħra",
            many: "fi żmien {0} snin oħra",
            other: "fi żmien {0} snin oħra"
          },
          past: {
            one: "sa sena ilu",
            few: "{0} snin ilu",
            many: "{0} snin ilu",
            other: "{0} snin ilu"
          }
        }
      },
      month: {
        displayName: "xahar",
        relative: {
          0: "Dan ix-xahar",
          1: "Ix-xahar id-dieħel",
          "-1": "Ix-xahar li għadda"
        },
        relativeTime: {
          future: {
            one: "sa xahar ieħor",
            few: "fi {0} xhur oħra",
            many: "fi {0} xhur oħra",
            other: "fi {0} xhur oħra"
          },
          past: {
            one: "xahar ilu",
            few: "{0} xhur ilu",
            many: "{0} xhur ilu",
            other: "{0} xhur ilu"
          }
        }
      },
      "month-short": {
        displayName: "Xahar",
        relative: {
          0: "Dan ix-xahar",
          1: "Ix-xahar id-dieħel",
          "-1": "Ix-xahar li għadda"
        },
        relativeTime: {
          future: {
            one: "sa xahar ieħor",
            few: "sa {0} xhur oħra",
            many: "sa {0} xhur oħra",
            other: "sa {0} xhur oħra"
          },
          past: {
            one: "{0} xahar ilu",
            few: "{0} xhur ilu",
            many: "{0} xhur ilu",
            other: "{0} xhur ilu"
          }
        }
      },
      day: {
        displayName: "jum",
        relative: {
          0: "illum",
          1: "għada",
          "-1": "lbieraħ"
        },
        relativeTime: {
          future: {
            one: "fi żmien ġurnata",
            few: "fi żmien {0} ġurnata oħra",
            many: "fi żmien {0} ġurnata oħra",
            other: "fi żmien {0} ġurnata oħra"
          },
          past: {
            one: "ġurnata ilu",
            few: "{0} ġranet ilu",
            many: "{0}-il ġurnata ilu",
            other: "{0}-il ġurnata ilu"
          }
        }
      },
      "day-short": {
        displayName: "Jum",
        relative: {
          0: "illum",
          1: "għada",
          "-1": "lbieraħ"
        },
        relativeTime: {
          future: {
            one: "fi żmien ġurnata",
            few: "fi żmien {0} ġurnata oħra",
            many: "fi żmien {0} ġurnata oħra",
            other: "fi żmien {0} ġurnata oħra"
          },
          past: {
            one: "ġurnata ilu",
            few: "{0} ġranet ilu",
            many: "{0}-il ġurnata ilu",
            other: "{0}-il ġurnata ilu"
          }
        }
      },
      hour: {
        displayName: "siegħa",
        relative: {
          0: "din is-siegħa"
        },
        relativeTime: {
          future: {
            one: "fi żmien siegħa oħra",
            few: "fi żmien {0} sigħat",
            many: "fi żmien{0} sigħat",
            other: "fi żmien {0} sigħat"
          },
          past: {
            one: "siegħa ilu",
            few: "{0} sigħat ilu",
            many: "{0} sigħat ilu",
            other: "{0} sigħat ilu"
          }
        }
      },
      "hour-short": {
        displayName: "siegħa",
        relative: {
          0: "din is-siegħa"
        },
        relativeTime: {
          future: {
            one: "fi żmien siegħa oħra",
            few: "fi żmien {0} sigħat",
            many: "+{0} h",
            other: "fi żmien {0} sigħat"
          },
          past: {
            one: "siegħa ilu",
            few: "{0} sigħat ilu",
            many: "{0} sigħat ilu",
            other: "{0} sigħat ilu"
          }
        }
      },
      minute: {
        displayName: "minuta",
        relative: {
          0: "din il-minuta"
        },
        relativeTime: {
          future: {
            one: "sa minuta oħra",
            few: "sa {0} minuti oħra",
            many: "sa {0} minuti oħra",
            other: "sa {0} minuti oħra"
          },
          past: {
            one: "minuta ilu",
            few: "{0} minuti ilu",
            many: "{0} minuti ilu",
            other: "{0} minuti ilu"
          }
        }
      },
      "minute-short": {
        displayName: "min.",
        relative: {
          0: "din il-minuta"
        },
        relativeTime: {
          future: {
            one: "sa min. oħra",
            few: "sa {0} min. oħra",
            many: "sa {0} min. oħra",
            other: "sa {0} min. oħra"
          },
          past: {
            one: "min. ilu",
            few: "{0} min. ilu",
            many: "{0} minuti ilu",
            other: "{0} min. ilu"
          }
        }
      },
      second: {
        displayName: "sekonda",
        relative: {
          0: "issa"
        },
        relativeTime: {
          future: {
            one: "sa {0} sekondi oħra",
            few: "sa {0} sekondi oħra",
            many: "sa {0} sekondi oħra",
            other: "sa {0} sekondi oħra"
          },
          past: {
            one: "sekonda ilu",
            few: "{0} sekondi ilu",
            many: "{0} sekondi ilu",
            other: "{0} sekondi ilu"
          }
        }
      },
      "second-short": {
        displayName: "sek.",
        relative: {
          0: "issa"
        },
        relativeTime: {
          future: {
            one: "sa {0} sekondi oħra",
            few: "sa {0} sek. oħra",
            many: "sa {0} sek. oħra",
            other: "sa {0} sekondi oħra"
          },
          past: {
            one: "sek. ilu",
            few: "{0} sek. ilu",
            many: "{0} sek. ilu",
            other: "{0} sek. ilu"
          }
        }
      }
    }
  }];
});